import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { login } from "../../actions/auth";
import Modal from "../common/Modal/Modal";
import { useSubmitGuard } from "../common/Helpers";

export function Login(props) {

    let email = "";
    if (typeof props.match.params.email !== 'undefined'){ email = props.match.params.email }

	const [userInfo, setUserInfo] = useState({email: email, password: ""})
	const { isSubmitting, guardedSubmit } = useSubmitGuard();

	const onSubmit = guardedSubmit((e) => {
		e.preventDefault();
		return props.login(userInfo.email, userInfo.password);
	});

	const onChange = (e) => setUserInfo({...userInfo, [e.target.name]: e.target.value });

	// const onCloseModal = () => {
    //     props.history.push("/");
    // }

	const status = useSelector(state => state.auth.status);

	if (status === "authenticated") {
		return <Redirect to="/dashboard" />;
	}
	
	return (
		<Modal slogan={true} className="login" >
			<form className="form" onSubmit={(e) => onSubmit(e)}>		
				<div className="inputs-wrapper gap-below-s">
					<div className="input-basic">				
						<input
							type="email"
							name="email"
							onChange={(e) => onChange(e)}
							value={userInfo.email}	
							id="email"
							required
						/>
						<label htmlFor="email">Email </label>
					</div>
					<div className="input-basic"> 
						<input
							type="password"
							name="password"
							onChange={(e) => onChange(e)}
							value={userInfo.password}
							id="password"
							required
						/>
						<label htmlFor="password">Password </label>
					</div>
				</div>
				<div className="flex-row center">
					<button style={{width: "100%"}} type="submit" id="login" className="btn pri gap-below-s gap-above-s" disabled={isSubmitting}>
						{isSubmitting ? "LOGGING IN..." : "LOG IN"}
					</button>
				</div>
			</form>
            <Link style={{width: "100%"}} id="register" className="btn sec gap-below-m" to="register">SIGN UP</Link>
			<p className="content2 light text-center gap-below-m">Forgot your password? <Link to="/forgot-password">Reset it.</Link></p>
		</Modal>
	);

}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { login })(Login);
